<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="110px">
				<el-form-item label="分类类型：" style="margin-bottom:10px">
					<el-radio-group v-model="form.cate_type" @input="groupInput">
						<el-radio :label="1">收入类目</el-radio>
						<el-radio :label="2">支出类目</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="一级分类列表：">
					<el-select class="select" v-model="form.cate_pid" clearable placeholder="一级分类列表">
						<el-option v-for="item in cateList" :key="item.cate_id" :label="item.cate_name"
							:value="item.cate_id" />
					</el-select>
				</el-form-item>
				<el-form-item label="分类名称：">
					<el-input class="input" v-model="form.cate_name" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="备注说明：">
					<el-input class="input" v-model="form.cate_remark" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="显示顺序：">
					<el-input class="input" v-model="form.cate_sort" placeholder="请输入内容"></el-input>
					<span class="span">数值越小越靠前</span>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm()">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		billCate
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '编辑新增',
				cateList: [], //一级分类列表
				form: {
					cate_type: 1, //分类类型;1=收入,2=支出
					cate_pid: '', //一级分类id
					cate_name: '', //分类名称
					cate_remark: '', //备注
					cate_sort: '' //排序
				}
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
					padding: '0 0'
				}
			}
		},
		mounted() {
			if (this.type != -1) {
				//详情编辑
				this.form.cate_id = this.type;
				this.getBillCateDetail();
			}
			this.getBillCateList();
		},
		methods: {

			//获取收支详情
			getBillCateDetail() {
				billCate({
					cate_id: this.form.cate_id
				}, 3).then(res => {
					if (res.code == 0) {
						res.data.cate_pid = res.data.cate_pid == 0 ? '' : res.data.cate_pid;
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
					}
				}).catch(err => {})
			},

			//获取收支分类列表
			getBillCateList() {
				billCate({
					cate_type: this.form.cate_type
				}, 4).then(res => {
					if (res.code == 0) {
						this.cateList = res.data
					}
				}).catch(err => {})
			},

			//group切换
			groupInput(val) {
				this.form.cate_pid = '';
				this.form.cate_type = val;
				this.getBillCateList();
			},

			//表单提交
			submitForm() {
				var type = this.type != -1 ? 2 : 0;
				billCate({
					...this.form
				}, type).then(res => {
					if (res.code == 0) {
						this.$emit('close', 0)
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.select {
		width: 175px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>